var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      directives: [
        { name: "drag", rawName: "v-drag" },
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      attrs: {
        title: "分配客户",
        visible: _vm.dialogVisible,
        width: "920px",
        "append-to-body": true,
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "before-close": _vm.cancel,
        top: "5vh",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c("template", { slot: "title" }, [
        _c("span", { staticClass: "title" }, [_vm._v("分配客户")]),
        _vm.isCheckCompany
          ? _c(
              "span",
              {
                staticClass: "edit",
                on: {
                  click: function ($event) {
                    _vm.isCheck = false
                  },
                },
              },
              [_c("i", { staticClass: "el-icon-edit-outline" }), _vm._v("编辑")]
            )
          : _vm._e(),
      ]),
      _c("div", { staticClass: "content" }, [
        _c(
          "div",
          { staticClass: "header" },
          [
            _c(
              "el-form",
              {
                ref: "form",
                attrs: {
                  model: _vm.form,
                  rules: _vm.rules,
                  "label-position": "top",
                },
              },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "选择分配客户", prop: "companyIds" } },
                  [
                    _c(
                      "el-select",
                      {
                        staticStyle: { width: "880px" },
                        attrs: {
                          multiple: "",
                          filterable: "",
                          clearable: "",
                          placeholder: "请选择",
                          disabled: _vm.isCheck,
                        },
                        on: { change: _vm.companyIdsChange },
                        model: {
                          value: _vm.form.companyIds,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "companyIds", $$v)
                          },
                          expression: "form.companyIds",
                        },
                      },
                      _vm._l(_vm.companyOptions, function (item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.label, value: item.value },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "data" },
          [
            _c("BaseTable", {
              attrs: {
                tableData: _vm.tableData,
                height: 450,
                isPager: false,
                border: true,
              },
              scopedSlots: _vm._u([
                {
                  key: "mblType",
                  fn: function (row) {
                    return _c(
                      "el-radio-group",
                      {
                        attrs: { disabled: _vm.isCheck },
                        model: {
                          value: row.scope.mblType,
                          callback: function ($$v) {
                            _vm.$set(row.scope, "mblType", $$v)
                          },
                          expression: "row.scope.mblType",
                        },
                      },
                      [
                        _c("el-radio", { attrs: { label: "" } }, [
                          _vm._v("全部"),
                        ]),
                        _c("el-radio", { attrs: { label: 0 } }, [
                          _vm._v("海运"),
                        ]),
                        _c("el-radio", { attrs: { label: 1 } }, [
                          _vm._v("空运"),
                        ]),
                      ],
                      1
                    )
                  },
                },
                {
                  key: "email",
                  fn: function (row) {
                    return _c(
                      "el-select",
                      {
                        attrs: { placeholder: "请选择", disabled: _vm.isCheck },
                        model: {
                          value: row.scope.email,
                          callback: function ($$v) {
                            _vm.$set(row.scope, "email", $$v)
                          },
                          expression: "row.scope.email",
                        },
                      },
                      _vm._l(
                        _vm.rowData?.supplierEmails,
                        function (item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: { label: item, value: item },
                          })
                        }
                      ),
                      1
                    )
                  },
                },
                {
                  key: "contact",
                  fn: function (row) {
                    return _c("el-input", {
                      attrs: { placeholder: "请输入", disabled: _vm.isCheck },
                      model: {
                        value: row.scope.contact,
                        callback: function ($$v) {
                          _vm.$set(row.scope, "contact", $$v)
                        },
                        expression: "row.scope.contact",
                      },
                    })
                  },
                },
                {
                  key: "remark",
                  fn: function (row) {
                    return _c("el-input", {
                      attrs: { placeholder: "请输入", disabled: _vm.isCheck },
                      model: {
                        value: row.scope.remark,
                        callback: function ($$v) {
                          _vm.$set(row.scope, "remark", $$v)
                        },
                        expression: "row.scope.remark",
                      },
                    })
                  },
                },
              ]),
            }),
          ],
          1
        ),
      ]),
      _c(
        "span",
        {
          staticClass: "footers flex_c_c",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "div",
            { staticClass: "cancel flex_c_c", on: { click: _vm.cancel } },
            [_vm._v("取消")]
          ),
          _c(
            "el-button",
            {
              directives: [
                {
                  name: "debounce-click",
                  rawName: "v-debounce-click",
                  value: _vm.ok,
                  expression: "ok",
                },
              ],
              staticClass: "ok flex_c_c",
              attrs: { disabled: !_vm.tableData.columns.length || _vm.isCheck },
            },
            [_vm._v("确定")]
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }